module.exports = __webpack_public_path__ + "img/email.9bf45a06.svg";